import { ExerciseInterface, ObjectiveInterface, PDFExamContainerInterface } from "../../interfaces/examInterfaces";
import { LayoutExamId, LayoutExamTypeKeys } from "../../enums/layoutExamTypes";
import { LegacyPDFContainer } from "./Layouts/Legacy/LegacyPDFContainer";
import { AllalinhornPDFContainer } from "./Layouts/Allalinhorn/AllalinhornPDFContainer";
import { COLORS } from "../../constants";
import { PizLinardPDFContainer } from "./Layouts/PizLinard/PizLinardPDFContainer";
import { GrandCombinPDFContainer } from "./Layouts/GrandCombin/GrandCombinPDFContainer";

export const PDFContainer = ({
  pageIndex,
  selectedObjective,
  pages,
  pageExercises,
  examName,
  totalPoints,
  imageUrls,
  solutionImageUrls,
  pageNumber,
  createPageNumbers,
  selectedLayout,
}: {
  pageIndex: number;
  selectedObjective: ObjectiveInterface;
  pages: ExerciseInterface[][];
  pageExercises: ExerciseInterface[];
  examName: string;
  totalPoints: number;
  imageUrls: { [key: string]: string };
  solutionImageUrls: { [key: string]: string };
  pageNumber: number;
  createPageNumbers: boolean;
  selectedLayout: LayoutExamTypeKeys;
}) => {
  let groupColorDark = getGroupColorDark();
  let groupColorLight = getGroupColorLight();
  const zoomFactor = 1;
  const layoutData: PDFExamContainerInterface = {
    pageIndex,
    selectedObjective,
    pages,
    pageExercises,
    examName,
    totalPoints,
    imageUrls,
    solutionImageUrls,
    pageNumber,
    createPageNumbers,
    zoomFactor,
    groupColorDark,
    groupColorLight,
  };

  function getGroupColorDark(): string {
    let groupId = selectedObjective?.id.toString()[1];
    if (groupId === "1") {
      return COLORS.ALGEBRA_DARK;
    }
    if (groupId === "2") {
      return COLORS.GEOMETRIE_DARK;
    }
    if (groupId === "3") {
      return COLORS.APPLIED_MATHS_DARK;
    }
    return COLORS.DIDACTO_DARK_GREY;
  }

  function getGroupColorLight(): string {
    let groupId = selectedObjective?.id.toString()[1];
    if (groupId === "1") {
      return COLORS.ALGEBRA_LIGHT;
    }
    if (groupId === "2") {
      return COLORS.GEOMETRIE_LIGHT;
    }
    if (groupId === "3") {
      return COLORS.APPLIED_MATHS_LIGHT;
    }
    return COLORS.DIDACTO_DARK_GREY;
  }

  switch (selectedLayout) {
    case LayoutExamId.LEGACY:
      return <LegacyPDFContainer {...layoutData} />;

    case LayoutExamId.ALLALINHORN:
      return <AllalinhornPDFContainer {...layoutData} />;

    case LayoutExamId.PIZ_LINARD:
      return <PizLinardPDFContainer {...layoutData} />;

    case LayoutExamId.GRAND_COMBIN:
      return <GrandCombinPDFContainer {...layoutData} />;

    default:
      return <LegacyPDFContainer {...layoutData} />;
  }
};
